export enum AllowedAdminUsernames {
  ANAS = 'anas',
  ADMIN = 'admin',
  ABDULKARIM = 'abdulkarim',
  RAKAN = 'rakan@recyclee.io',
}

export enum UserRole {
  ADMIN = "admin",
  RECYCLER = "recycler",
  WASTE_OUTLET = "waste_outlet",
  TRUCK_CO = "truck_co",
  TRUCKER = "trucker",

  WASTE_OUTLET_ADMIN = "waste_outlet_admin",
  WASTE_OUTLET_OPS_MANAGER = "waste_outlet_ops_manager",
  WASTE_OUTLET_STAFF = "waste_outlet_staff",

  CHARITY_ADMIN = "charity_admin",
  CHARITY_OPS_MANAGER = "charity_ops_manager",
  CHARITY_STAFF = "charity_staff",

  RECYCLER_ADMIN = "recycler_admin",
  RECYCLER_OPS_MANAGER = "recycler_ops_manager",
  RECYCLER_STAFF = "recycler_staff",

  TRUCK_CO_ADMIN = "truck_co_admin",
  TRUCK_CO_OPS_MANAGER = "truck_co_ops_manager",
  TRUCK_CO_STAFF = "truck_co_staff",
}

export interface LoginRequest {
  username?: string;
  phone?: string;
  password: string;
}

export enum ReadOnlyAdminUsernames {}

export interface UserData {
  permissions?: string[] | Record<string, string[]>;
  /** Legacy role names by org id, kept alongside the flat `permissions` grant list during the permission-system migration. */
  permissions_legacy?: Record<string, string[]>;
  sites?: Record<string, string[]> | null;
  role?: string;
  organization_id?: string;
  email?: string;
  full_name?: string;
  first_name?: string | null;
  last_name?: string | null;
  gender?: string | null;
  nationality?: string | null;
  date_of_birth?: string | null;
  iban?: string | null;
  onesignal_player_id?: string;
  driver_license_number?: string;
  vehicle_registration_number?: string;
  driver_license_expiry?: string | null;
  [key: string]: any;
}

export interface RegisterRequest {
  username?: string;
  password: string;
  password_confirm: string;
  phone?: string | null;
  data: UserData;
}

export interface RefreshTokenRequest {
  refresh_token: string;
}

export interface LoginResponse {
  access_token: string;
  refresh_token: string;
  token_type?: string;
}

export interface UserSchema {
  id?: string;
  sub?: string;
  username: string;
  email?: string;
  full_name?: string;
  phone?: string | null;
  role?: string;
  organization_id?: string;
  organization_name?: string;
  is_active?: boolean;
  status?: string;
  created_at?: string;
  updated_at?: string;
  data?: UserData;
  exp?: number;
  iat?: number;
}

export interface UpdateUserRequest {
  username?: string | null;
  phone?: string | null;
  status?: string | null;
  data?: Partial<UserData> | null;
}

export interface ForgotPasswordRequest {
  username: string;
  platform: "OPS" | "ZERO" | "360" | "ADMIN" | "MARKET";
}

export interface ResetPasswordRequest {
  token: string;
  new_password: string;
  new_password_confirm: string;
}

/** JWT access token payload — permissions at root after PR2 migration. */
export interface AuthTokenPayload {
  sub: string;
  username: string;
  typ: string;
  exp: number;
  iat: number;
  permissions: string[] | Record<string, string[]>;
  platform_permissions?: string[];
  sites?: Record<string, string[]>;
  is_pilot?: boolean;
}
